import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { loginUser } from '../../redux/actions/userActions';
import chesssLogo from '../../images/chessslogo.png';
import mansalva from '../../images/Mansalva/Mansalva-Regular.ttf';
// Rate limiting
import { checkRateLimit } from '../../util/rateLimiter';
import { getRateLimit, buildGlobalRateKey } from '../../util/rateLimitConfig';

const LoginMobile = ({ loginUser, UI }) => {
  const [formData, setFormData] = useState({
    identifier: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [rateLimitError, setRateLimitError] = useState('');
  const history = useHistory();

  // Update errors from Redux
  useEffect(() => {
    if (UI.errors) {
      setErrors(UI.errors);
    }
  }, [UI.errors]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Client-side validation
    const newErrors = {};
    if (!formData.identifier.trim()) {
      newErrors.identifier = 'Username or Email is required';
    }
    if (!formData.password.trim()) {
      newErrors.password = 'Password is required';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Rate limiting check for login attempts
    const config = getRateLimit('SIGNIN_ATTEMPT', 'free');
    const rateKey = buildGlobalRateKey('anonymous', 'signin_attempt');
    
    const isLimited = checkRateLimit({
      key: rateKey,
      limit: config.limit,
      windowMs: config.windowMs
    });

    if (isLimited) {
      setRateLimitError('Too many login attempts. Please wait then try again.');
      setErrors({});
      return;
    }

    // Clear any previous rate limit errors
    setRateLimitError('');

    loginUser(formData, history);
  };

  const isFormValid = formData.identifier.trim() !== '' && formData.password.trim() !== '';
  const isDisabled = UI.loading || !isFormValid;

  return (
    <div style={{
      width: '100vw',
      height: '100dvh', // Full viewport height
      backgroundColor: '#000',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      paddingTop: 'calc(env(safe-area-inset-top) + 20px)', // iPhone notch safe area
      paddingBottom: 'calc(env(safe-area-inset-bottom) + 20px)', // iPhone gesture area + padding
      boxSizing: 'border-box'
    }}>
      <style>
        {`
          @font-face {
            font-family: 'Mansalva';
            src: url(${mansalva}) format('truetype');
            font-weight: normal;
            font-style: normal;
          }
        `}
      </style>
      {/* Logo and Title */}
      <div style={{
        textAlign: 'center',
        marginBottom: '40px'
      }}>
        <img
          src={chesssLogo}
          alt="Chess Social"
          style={{
            width: '80px',
            height: '80px',
            marginBottom: '20px'
          }}
        />
        <h1 style={{
          fontFamily: 'Mansalva, cursive',
          color: 'gold',
          fontSize: '32px',
          fontWeight: 'normal',
          margin: 0,
          marginBottom: '10px'
        }}>
          Log in to ChessThread
        </h1>
        {/* <p style={{
          color: '#888',
          fontSize: '16px',
          margin: 0
        }}>
          Sign in to continue your chess journey
        </p> */}
      </div>

      {/* Login Form */}
      <form onSubmit={handleSubmit} style={{
        width: '100%',
        maxWidth: '400px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }}>
        {/* Rate limit error message */}
        {rateLimitError && (
          <div style={{
            color: 'white',
            backgroundColor: '#ff6b6b',
            padding: '12px 16px',
            borderRadius: '8px',
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: 'bold'
          }}>
            {rateLimitError}
          </div>
        )}

        {/* Username/Email Field */}
        <div>
          <label style={{
            color: '#ccc',
            fontSize: '14px',
            marginBottom: '8px',
            display: 'block'
          }}>
            Username or Email
          </label>
          <input
            name="identifier"
            type="text"
            value={formData.identifier}
            onChange={handleChange}
            placeholder="Enter your username or email"
            style={{
              width: '100%',
              padding: '12px 16px',
              backgroundColor: '#ffffff',
              border: errors.identifier ? '2px solid #ff0050' : '2px solid #ccc',
              borderRadius: '8px',
              color: '#000000',
              fontSize: '16px',
              outline: 'none',
              boxSizing: 'border-box'
            }}
          />
          {errors.identifier && (
            <div style={{
              color: '#ff0050',
              fontSize: '14px',
              marginTop: '5px'
            }}>
              {errors.identifier}
            </div>
          )}
        </div>

        {/* Password Field */}
        <div>
          <label style={{
            color: '#ccc',
            fontSize: '14px',
            marginBottom: '8px',
            display: 'block'
          }}>
            Password
          </label>
          <input
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Enter your password"
            style={{
              width: '100%',
              padding: '12px 16px',
              backgroundColor: '#ffffff',
              border: errors.password ? '2px solid #ff0050' : '2px solid #ccc',
              borderRadius: '8px',
              color: '#000000',
              fontSize: '16px',
              outline: 'none',
              boxSizing: 'border-box'
            }}
          />
          {errors.password && (
            <div style={{
              color: '#ff0050',
              fontSize: '14px',
              marginTop: '5px'
            }}>
              {errors.password}
            </div>
          )}
        </div>

        {/* General Error */}
        {errors.general && (
          <div style={{
            color: '#ff0050',
            fontSize: '14px',
            textAlign: 'center',
            backgroundColor: 'rgba(255, 0, 80, 0.1)',
            padding: '12px',
            borderRadius: '8px',
            border: '1px solid rgba(255, 0, 80, 0.3)'
          }}>
            {errors.general}
          </div>
        )}

        {/* Login Button */}
        <button
          type="submit"
          disabled={isDisabled}
          style={{
            width: '100%',
            padding: '15px',
            backgroundColor: isDisabled ? '#666' : '#ff0050',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: isDisabled ? 'default' : 'pointer',
            opacity: isDisabled ? 0.7 : 1,
            marginTop: '10px'
          }}
        >
          {UI.loading ? 'Logging In...' : 'Log In'}
        </button>

        {/* Forgot Password Link */}
        <Link
          to="/reset-password"
          style={{
            color: 'gold',
            fontSize: '14px',
            textAlign: 'center',
            textDecoration: 'none',
            marginTop: '10px',
            display: 'block'
          }}
        >
          Forgot your password?
        </Link>
      </form>

      {/* Sign Up Link */}
      <div style={{
        marginTop: '40px',
        textAlign: 'center'
      }}>
        <span style={{ color: '#888', fontSize: '16px', marginRight: '5px', fontWeight: 'bold' }}>
          New to ChessThread?{' '}
        </span>
        <Link
          to="/signup"
          style={{
            color: 'gold',
            fontSize: '16px',
            textDecoration: 'none'
          }}
        >
          Create Account
        </Link>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  UI: state.UI
});

const mapDispatchToProps = {
  loginUser
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginMobile);